import React, { useState, useEffect } from "react";
import allTeams from "../../data/teams"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import apiUrl from "../../config";
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
const Montly = ({ team }) => {
  // Initialize selectedMonth and selectedYear directly
  const date = new Date();
  const initialDay = String(date.getDate()).padStart(2, "0");
  const initialYear = date.getFullYear();
  const initialMonth = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const [selectedMonth, setSelectedMonth] = useState(initialMonth);
  const [selectedYear, setSelectedYear] = useState(initialYear);
  const [selectedFulldate, setSelectedFulldate] = useState(
    `${initialYear}-${selectedMonth}`
  );
  const [schedule, setSchedule] = useState({});

  const fetchScheduleMontly = async (team, selectedFulldate) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/club-schedule/${team}/${selectedFulldate}`
      ); // Adjust the endpoint as necessary
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const gamesSchedule = data.games || [];
      const groupedSchedule = {};
      gamesSchedule.forEach((game) => {
        const gameDate = game.gameDate; // Assuming `game.date` is in the format 'YYYY-MM-DD'
        const day = gameDate.split("-")[2]; // Extract the day part
        if (!groupedSchedule[day]) {
          groupedSchedule[day] = [];
        }
        groupedSchedule[day].push(game);
      });
      setSchedule(groupedSchedule); // Update the schedule state
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  const numberToMonth = (num) => {
    if(num === 13){
      num = 1;
    }
    if(num === 0){
      num = 12;
    }
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    if(num === 13) num = 1;
    if(num === -1) num = 12;
    const index = parseInt(num, 10) - 1; // Convert to integer and adjust for 0-based index
    return months[index] || "Invalid month";
  };

  const getDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate(); // Month is 1-based, so no need to add 1
  };

  function getDayOfWeek(dateStr) {
    const refDate = new Date("2025-10-06"); // Known Monday
    const inputDate = new Date(dateStr);

    const msInDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round((inputDate - refDate) / msInDay);

    // Day index where Sunday = 0, Monday = 1, ..., Saturday = 6
    const refDayIndex = 1; // Monday as index 1 in Sunday-start week
    const dayIndex = (refDayIndex + (diffDays % 7) + 7) % 7;

    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[dayIndex];
  }

  const handleMonthChange = (newMonth) => {
    let newYear = selectedYear;
    if (newMonth == 13) {
      newMonth = 1;
      newYear = selectedYear + 1;
    }
    if (newMonth == 0) {
      newMonth = 12;
      newYear = selectedYear - 1;
    }
    setSelectedMonth(newMonth);
    setSelectedYear(newYear);
    setSelectedFulldate(`${newYear}-${String(newMonth).padStart(2, "0")}`);
    fetchScheduleMontly(team, `${newYear}-${String(newMonth).padStart(2, "0")}`);
  }

  useEffect(() => {
    fetchScheduleMontly(team, selectedFulldate);
  }, [team, selectedFulldate]);

  return (
    <div className="teamContent">
      <h2>CALENDAR</h2>
      <div>
      <div className="montlyNav">
        <div><button onClick={() => handleMonthChange(selectedMonth - 1)}>
          <ArrowBackIosNewSharpIcon />
          {numberToMonth(Number(selectedMonth) - 1)}
        </button>
        </div>
        <div>
        <h3>{numberToMonth(selectedMonth)}</h3>
        </div>
        <div>
        <button onClick={() => handleMonthChange(Number(selectedMonth) + 1)}>
          {numberToMonth(Number(selectedMonth) + 1)}
          <ArrowForwardIosSharpIcon />
        </button>
        </div>
      </div>
      </div>
      <div>
        {(() => {
          // Calculate the day of the week for the first day of the month
          const firstDayOfMonth = new Date(selectedYear, selectedMonth - 1, 1); // Subtract 1 from selectedMonth
          const firstDayOfWeek = firstDayOfMonth.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
          // Add empty squares for days before the first day of the month
          const emptySquaresBefore = Array.from(
            { length: firstDayOfWeek },
            (_, i) => (
              <div
                key={`empty-before-${i}`}
                className="emptySquare"
              ></div>
            )
          );

          // Add squares for each day of the month
          const daysInMonth = Array.from(
            { length: getDaysInMonth(selectedMonth, selectedYear, initialDay) },
            (_, i) => {
              const day = i + 1;
              const fullDate = `${selectedYear}-${String(
                selectedMonth
              ).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
              const dayName = getDayOfWeek(fullDate); // Use the new function to get the day name

              const getGameTime = (gameTimeUTC, gameTimeMinus) => {
                let gameTime = gameTimeUTC.slice(11, 13);
                let gameMinutes = gameTimeUTC.slice(14, 16);
                if (gameTime < 7) {
                  gameTime = parseInt(gameTime) + 24;
                }
                let localTime = parseInt(gameTime) + parseInt(gameTimeMinus);
                return localTime + ":" + gameMinutes;
              };

              const paddedDay = String(day).padStart(2, "0");
              const isToday = (paddedDay === initialDay && initialMonth == selectedMonth) ? "today" : "";
              const isPass = (paddedDay < initialDay && selectedYear <= initialYear && selectedMonth <= initialMonth ) || (initialMonth > selectedMonth && selectedYear <= initialYear)  ? "yesthurday" : "";

              return (
                <div className={`calendertile ${isToday} ${isPass}`} key={day} style={{}}>
                  <strong>{`${day}`}</strong>
                  <div key={day+day} id={day}>
                    {schedule[paddedDay] ? (
                      schedule[paddedDay].map((game, index) => (
                       <Link to={game.gameState != "FUT" ? `/game/${game.id}` : ""} key={`${day}-${index}`}>
                        <div key={index} className={`gameDay`}>
                          <div className="gameScore">
                            <div>
                              <img
                                src={`https://assets.nhle.com/logos/nhl/svg/${game.awayTeam.abbrev.toUpperCase()}_dark.svg`}
                              />
                              {game.awayTeam.score !== null ? (
                                <span style={{ fontWeight: "bold" }}>
                                  {game.awayTeam.score}
                                </span>
                              ) : (
                                <span> - </span>
                              )}
                            </div>
                            <div>vs</div>
                            <div>
                              {" "}
                              <img
                                width={35}
                                src={`https://assets.nhle.com/logos/nhl/svg/${game.homeTeam.abbrev.toUpperCase()}_dark.svg`}
                              />
                              {game.homeTeam.score !== null ? (
                                <span style={{ fontWeight: "bold" }}>
                                  {game.homeTeam.score}
                                </span>
                              ) : (
                                <span> - </span>
                              )}
                            </div>
                          </div>
                          <p style={{ fontSize: 10 }}>
                            {game.venue.default} at{" "}
                            {getGameTime(
                              game.startTimeUTC,
                              game.venueUTCOffset
                            )}
                          </p>
                        </div>
                    </Link>                      
                      ))
                    ) : (
                      <div className=""></div>
                    )}
                  </div>
                </div>
              );
            }
          );

          // Add empty squares for days after the last day of the month
          const totalSquares =
            emptySquaresBefore.length +
            getDaysInMonth(selectedMonth, selectedYear);
          const emptySquaresAfter = Array.from(
            { length: (7 - (totalSquares % 7)) % 7 },
            (_, i) => (
              <div
                key={`empty-after-${i}`}
                className="emptySquare"
              ></div>
            )
          );

          // Combine empty squares and days in the month
          const allSquares = [
            ...emptySquaresBefore,
            ...daysInMonth,
            ...emptySquaresAfter,
          ];

          // Group all squares into rows of 7
          const rows = [];
          for (let i = 0; i < allSquares.length; i += 7) {
            rows.push(allSquares.slice(i, i + 7));
          }

          // Render rows
          return rows.map((row, rowIndex) => (
            <div
              className="calenderRow"
              key={`row-${rowIndex}`}
            >
              {row}
            </div>
          ));
        })()}
      </div>
    </div>
  );
};

export default Montly;
